// import { get } from 'browser-cookies'
import { JwtUser } from './Models/JwtUser'
import { resolve } from 'dns'
import { LocalStoreManager } from './StorageManager'
import { PortalUrl, PortalUrlValues } from './Models/Environments'
import { PortalUrlProvider } from './PortalUrlProvider'
class AclUserInfoEndpoint {
  public static path: string = '/ec/acl/security/user/info'

  public static concatenateUrlPart(part1: string, part2: string): string {
    if (!part1.endsWith('/') && !part2.startsWith('/')) {
      return part1 + '/' + part2
    }
    if (part1.endsWith('/') && part2.startsWith('/')) {
      return part1 + part2.substring(1)
    }
    return part1 + part2
  }
  public static endPointFullUrl(base: string = ''): string {
    if (base !== '') {
      return AclUserInfoEndpoint.concatenateUrlPart(base, AclUserInfoEndpoint.path)
    } else {
      if (document.getElementsByTagName('base')[0]) {
        const baseHref = document.getElementsByTagName('base')[0].href
        return AclUserInfoEndpoint.concatenateUrlPart(baseHref, AclUserInfoEndpoint.path)
      } else {
        if (
          window.document &&
          window.document.location &&
          window.document.location.origin &&
          window.document.location.origin.indexOf('http://localhost:') === 0
        ) {
          return AclUserInfoEndpoint.concatenateUrlPart(
            window.document.location.origin,
            AclUserInfoEndpoint.path
          )
        } else {
          if (window.document && window.document.location && window.document.location.origin) {
            const pathArray = window.document.location.pathname.split('/')
            const secondLevelLocation = pathArray[1]
            if (secondLevelLocation !== '') {
              return (
                window.document.location.origin +
                '/' +
                secondLevelLocation +
                AclUserInfoEndpoint.path
              )
            } else {
              return AclUserInfoEndpoint.concatenateUrlPart(
                window.document.location.origin,
                AclUserInfoEndpoint.path
              )
            }
          } else {
            throw new Error(
              'Could not find the <base/> tag to extract the base href.You must create a <base href="http://mybase.path"/> in the header section of you html page.'
            )
          }
        }
      }
    }
  }
}
/**
 * @private-doc
 */
export class AuthotizationHandler {
  private _baseHref: string = ''
  private _localStorage: LocalStoreManager = new LocalStoreManager()
  constructor(baseHref: string = '') {
    this._baseHref = baseHref
  }
  public DeleteAutorizationInfo(): void {
    this._localStorage.deleteData(this._localStorage.getDBKEY_USER_DATA())
  }
  public GetUserInfo(callback?: (user?: JwtUser) => void): Promise<JwtUser> {
    this.ensureUserIsUpdated()
    const localUser = this._localStorage.getData(this._localStorage.getDBKEY_USER_DATA()) as JwtUser
    let userObj = new JwtUser()
    if (localUser) {
      Object.assign(userObj, localUser)
    }
    if (localUser) {
      let call = new Promise<JwtUser>(resolve => {
        PortalUrlProvider.PortalUrl = this.getPortalUrl(userObj)
        if (callback) {
          callback(userObj)
        }

        resolve(userObj)
      })

      return call
    } else {
      let call = this.getRequest(AclUserInfoEndpoint.endPointFullUrl(this._baseHref))
      call
        .then(user => {
          if (user) {
            Object.assign(userObj, user)
            this._localStorage.saveSessionData(userObj, this._localStorage.getDBKEY_USER_DATA())
            this._localStorage.saveSessionData(
              this.getCookieByName('.ISS.EC.CHECK'),
              this._localStorage.getCookieValidationTokenKey()
            )
            PortalUrlProvider.PortalUrl = this.getPortalUrl(userObj)
            if (callback) {
              callback(userObj)
            }
            return userObj
          } else {
            if (callback) {
              callback()
            }
            return null
          }
        })
        .catch(error => {
          console.log(error)
        })

      return call
    }
  }
  public SignIn(redirectTo: string = '', Environment: string = 'prod'): void {
    let portalUrl = PortalUrl.PROD
    portalUrl = this._getPortalUrlForEnvironment(Environment)
    let signInUrl = portalUrl + '/ecportal/login'

    signInUrl =
      signInUrl +
      '?redirectTo=' +
      encodeURIComponent(redirectTo ? redirectTo : window.location.href)
    window.location.href = signInUrl
  }
  public getPortalUrl(user: JwtUser, isForIframe: boolean = false): string {
    let portalUrl = PortalUrl.PROD
    portalUrl = this._getPortalUrlForEnvironment(
      user.Environment ? user.Environment.toLocaleLowerCase() : 'prod'
    )
    // console.log(portalUrl);
    return portalUrl + (isForIframe === true ? '/ecportalapproval' : '/ecportal')
  }
  public _getPortalUrlForEnvironment(Environment: string): PortalUrlValues {
    let portalUrl = PortalUrl.PROD

    switch (Environment.toLocaleLowerCase()) {
      case 'dev':
        portalUrl = PortalUrl.DEV
        break
      case 'training':
        portalUrl = PortalUrl.TRAINING
        break
      case 'qa':
        portalUrl = PortalUrl.QA
        break
      case 'prod':
        portalUrl = PortalUrl.PROD
        break
      default:
        portalUrl = PortalUrl.PROD
        break
    }
    // console.log(portalUrl);
    return portalUrl
  }

  public deleteAuthorizationCookie(): void {
    const cookieName = '.ISS.AUTH';
    const hostname = window.location.hostname;

    let domain = '';
    let attributes = '';

    if (hostname.endsWith('pbcgov.org')) {
        domain = '.pbcgov.org';
        attributes = `domain=${domain}; path=/; SameSite=Lax`;
    }else if(hostname.endsWith('pbc.gov')){
      domain = '.pbc.gov';
      attributes = `domain=${domain}; path=/; SameSite=Lax`;
    }else if (hostname.endsWith('co.palm-beach.fl.us')) {
        domain = '.co.palm-beach.fl.us';
        attributes = `domain=${domain}; path=/; SameSite=None; Secure`;
    } else if (hostname.endsWith('pbcgov.com')) {
        domain = '.pbcgov.com';
        attributes = `domain=${domain}; path=/; SameSite=None; Secure`;
    } else {
        console.log('Domain not recognized for cookie deletion.');
        return;
    }

    // Set the cookie with an expiration date in the past to delete it
    document.cookie = `${cookieName}=deleted; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${attributes}`;
    
    console.log(`Deleted cookie ${cookieName} on domain ${domain}`);
  }

  private getRequest(url: string, count: number = 1): Promise<JwtUser> {
    const me = this
    return new Promise<JwtUser>(function(resolve, reject) {
      const request = new XMLHttpRequest()

      request.onload = function() {
        if (this.status === 200) {
          if (this.response) {
            try {
              let user = JSON.parse(this.response) as JwtUser
              resolve(user)
            } catch (error) {
              reject(error)
            }
          } else {
            resolve()
          }
        } else {
          reject(new Error(this.statusText))
        }
      }
      request.onerror = function() {
        reject(new Error('XMLHttpRequest Error: ' + this.statusText))
      }
      request.open('GET', url)
      // request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      request.withCredentials = true
      request.send()
    })
  }
  private ensureUserIsUpdated(): void {
    const checkData = this._localStorage.getData(this._localStorage.getCookieValidationTokenKey())
    if (!checkData) {
      this.DeleteAutorizationInfo()
    } else {
      const cookie = this.getCookieByName('.ISS.EC.CHECK')
      if (!cookie || cookie !== checkData) {
        this.DeleteAutorizationInfo()
      }
    }
  }
  private getCookieByName(name: string): string {
    const value = '; ' + document.cookie
    const parts = value.split('; ' + name + '=')
    if (parts && parts.length === 2) {
      const poped = parts.pop()
      if (poped) {
        const val = poped.split(';').shift()
        return val ? val : ''
      } else {
        return ''
      }
    } else {
      return ''
    }
  }
  
}
